import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { Funcionalidade } from 'src/app/_models/funcionalidade/funcionalidade';
import { FuncionalidadeService } from 'src/app/_services/funcionalidade.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { FuncionalidadeResponse } from 'src/app/_models/response/funcionalidadeResponse';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { PerfilService } from 'src/app/_services/perfil.service';
import { AplicacaoService } from 'src/app/_services/aplicacao.service';
import { Aplicacao } from 'src/app/_models/usuario/aplicacao';
import {PickListModule} from 'primeng/picklist';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';

@Component({
    templateUrl: 'funcionalidade.component.html',
    styleUrls: ['../../../demo/view/tabledemo.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService]
})

export class FuncionalidadeComponent implements OnInit {

  funcionalidadeDialog: boolean;
  funcionalidades: Funcionalidade[];
  funcionalidade: Funcionalidade;
  selectedFuncionalidades: Funcionalidade[];
  submitted: boolean;
  cols: any[];
  usuario: Usuario;
  perfis: Perfil[];
  selectedPerfis: any[];
  aplicacoes: any = [];
  aplicacao: Aplicacao;
  selectedItem: any = [];
  items: any = [];

  sourcePerfil: any[];
  targetPerfil: any[];

  funcionalidadePai: Funcionalidade;
  funcionalidadesPai: Funcionalidade[];

  selectedPerfil: Perfil;

  perfil: Perfil;

  blocked: boolean;
  manterFuncionalidade: string;
  labelHeader: string;

  constructor(private funcionalidadeService: FuncionalidadeService, private messageService: MessageService,
              private confirmationService: ConfirmationService, private breadcrumbService: AppBreadcrumbService,
              private authenticationService: AuthenticationService, private perfilService: PerfilService,
              private aplicacaoService: AplicacaoService, private bscobrancaTranslate: BscobrancaTranslate) {
        this.manterFuncionalidade = this.bscobrancaTranslate.getText('menu.manterFuncionalidade');
        this.labelHeader = this.bscobrancaTranslate.getText('menu.administracao');
        this.breadcrumbService.setItems([
            { label: this.labelHeader },
            { label: this.manterFuncionalidade, routerLink: ['/administracao/funcionalidade/funcionalidade'] }
        ]);
    }


  ngOnInit(): void {
    this.usuario = this.authenticationService.atualUserValue;
    this.perfil = this.authenticationService.atualUserPerfilValue;
    this.funcionalidadeService.getAll().toPromise().then(data => this.funcionalidades = data);
    this.funcionalidadeService.getAll().toPromise().then(data => this.funcionalidadesPai = data);
    this.perfilService.getAll().toPromise().then(data => this.perfis = data);
    this.aplicacaoService.getAplicaoPorEmpresa(this.usuario.empresa).toPromise().then(data => this.aplicacoes = data);
    this.cols = [
            { field: 'codFuncionalidadeApp', header: 'Codigo Funcionalidade' },
            { field: 'dscFuncionalidadeApp', header: 'Descricao Funcionalidade' },
            { field: 'nmeFuncionalidadeApp', header: 'Nome Funcionalidade' },
            { field: 'nmeGrupo', header: 'Grupo Funcionalidade' },
            { field: 'urlPath', header: 'URL' }
        ];
  }

  openNew() {
        this.funcionalidadeService.getAll().toPromise().then(data => this.funcionalidadesPai = data);
        this.funcionalidade = {};
        this.funcionalidadePai = {};
        this.selectedPerfis = [];
        this.aplicacao = {};
        this.submitted = false;
        this.funcionalidadeDialog = true;
        this.perfilService.getAll().toPromise().then(data => this.sourcePerfil = data);
        this.targetPerfil = [];
        this.blocked = false;
   }

   deleteselectedFuncionalidades() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.funcionalidades = this.funcionalidades.filter(val => !this.selectedFuncionalidades.includes(val));
                this.selectedFuncionalidades = null;
                this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Funcionalidades Excluidas', life: 3000 });
            }
        });
    }

    editFuncionalidade(funcionalidade: Funcionalidade) {
        this.blocked = false;
        this.funcionalidadeService.getAll().toPromise().then(data => this.funcionalidadesPai = data);
        this.aplicacao = funcionalidade.aplicacao;
        this.funcionalidadePai = funcionalidade.codFuncionalidadePrincipal;
        // tslint:disable-next-line: prefer-for-of
        for (let x = 0; x < funcionalidade.authPerfis.length; x++) {
            this.perfis = this.perfis.filter(val => val.codPerfil !== funcionalidade.authPerfis[x].codPerfil);
        }
        this.sourcePerfil = this.perfis;
        this.targetPerfil = funcionalidade.authPerfis;
        this.funcionalidade = { ...funcionalidade };
        this.funcionalidadeDialog = true;
    }

     viewFuncionalidade(funcionalidade: Funcionalidade) {
        this.blocked = true;
        this.funcionalidadeService.getAll().toPromise().then(data => this.funcionalidadesPai = data);
        this.aplicacao = funcionalidade.aplicacao;
        this.funcionalidadePai = funcionalidade.codFuncionalidadePrincipal;
        // tslint:disable-next-line: prefer-for-of
        for (let x = 0; x < funcionalidade.authPerfis.length; x++) {
            this.perfis = this.perfis.filter(val => val.codPerfil !== funcionalidade.authPerfis[x].codPerfil);
        }
        this.sourcePerfil = this.perfis;
        this.targetPerfil = funcionalidade.authPerfis;
        this.funcionalidade = { ...funcionalidade };
        this.funcionalidadeDialog = true;
    }

    deleteEmpresa(funcionalidade: Funcionalidade) {
        this.confirmationService.confirm({
            message: this.bscobrancaTranslate.getText('mensagens.funcionalidade-001') + funcionalidade.nmeFuncionalidadeApp + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.funcionalidadeService.deletar(funcionalidade).subscribe(
                    (funcionalidadeResponse: FuncionalidadeResponse) => {
                        if (funcionalidadeResponse) {
                            if (funcionalidadeResponse.codigo === 0) {
                                this.funcionalidades = this.funcionalidades.
                                    filter(val => val.codFuncionalidadeApp !== funcionalidadeResponse.funcionalidade.codFuncionalidadeApp);
                                this.funcionalidade = {};
                                this.messageService.add({
                                    severity: 'success', summary: 'Successful', detail: this.bscobrancaTranslate.getText('mensagens.funcionalidade-002'),
                                    life: 3000
                                });
                            } else {
                                this.messageService.add({ severity: 'error', summary: 'Error', detail: funcionalidadeResponse.mensagem,
                                life: 3000 });
                            }
                        } else {
                            this.messageService.add({
                                severity: 'error', summary: 'Error',
                                detail: this.bscobrancaTranslate.getText('mensagens.funcionalidade-003'), life: 3000 });
                        }
                    });
            }
        });
    }


   saveFuncionalidade() {
        this.submitted = true;
        const error = this.validateFuncionalidade();
        if (error !== '') {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
        } else {
            if (this.funcionalidade.nmeFuncionalidadeApp.trim()) {
                if (this.funcionalidade.codFuncionalidadeApp) {
                    console.log(this.funcionalidade);
                    this.funcionalidade.aplicacao = this.aplicacao;
                    this.funcionalidade.authPerfis = this.targetPerfil;
                    if (this.funcionalidadePai && this.funcionalidadePai.codFuncionalidadeApp > 0) {
                        this.funcionalidade.codFuncionalidadePrincipal = this.funcionalidadePai;
                    }
                    this.funcionalidadeService.atualizar(this.funcionalidade).subscribe(
                        (funcionalidadeResponse: FuncionalidadeResponse) => {
                            if (funcionalidadeResponse) {
                                if (funcionalidadeResponse.codigo === 0) {
                                    this.funcionalidades[this.findIndexById(funcionalidadeResponse.funcionalidade.codFuncionalidadeApp)]
                                        = this.funcionalidade;
                                    this.messageService.add({ severity: 'success', summary: 'Successful',
                                    detail: this.bscobrancaTranslate.getText('mensagens.funcionalidade-004'),
                                    life: 3000 });
                                    this.funcionalidadeService.getAll().
                                            toPromise().then(data => this.funcionalidades = data);
                                } else {
                                    this.messageService.add({ severity: 'error', summary: 'Error', detail: funcionalidadeResponse.mensagem,
                                    life: 3000 });
                                }
                            } else {
                                this.messageService.add({
                                    severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.funcionalidade-005'),
                                    life: 3000
                                });
                            }
                        });
                }
                else {
                    this.funcionalidade.aplicacao = this.aplicacao;
                    this.funcionalidade.authPerfis = this.targetPerfil;
                    if (this.funcionalidadePai && this.funcionalidadePai.codFuncionalidadeApp > 0) {
                        this.funcionalidade.codFuncionalidadePrincipal = this.funcionalidadePai;
                    }
                    this.funcionalidadeService.inserir(this.funcionalidade).subscribe(
                        (funcionalidadeResponse: FuncionalidadeResponse) => {
                            if (funcionalidadeResponse) {
                                if (funcionalidadeResponse.codigo === 0) {
                                    this.funcionalidades.push(funcionalidadeResponse.funcionalidade);
                                    this.messageService.add({ severity: 'success', summary: 'Successful',
                                    detail: this.bscobrancaTranslate.getText('mensagens.funcionalidade-006'), life: 3000 });
                                    this.funcionalidadeService.getAll().
                                            toPromise().then(data => this.funcionalidades = data);
                                } else {
                                    this.messageService.add({ severity: 'error', summary: 'Error', detail: funcionalidadeResponse.mensagem,
                                    life: 3000 });
                                }
                            } else {
                                this.messageService.add({
                                    severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.funcionalidade-007'),
                                    life: 3000
                                });
                            }
                        });
                }

                this.funcionalidades = [...this.funcionalidades];
                this.funcionalidadeDialog = false;
                this.funcionalidade = {};
            }
        }

    }


    validateFuncionalidade() {
        if (!this.funcionalidade.nmeFuncionalidadeApp) {
           return  this.bscobrancaTranslate.getText('mensagens.funcionalidade-008');
        }
        if (!this.funcionalidade.dscFuncionalidadeApp) {
            return  this.bscobrancaTranslate.getText('mensagens.funcionalidade-009');
        }
        if (!this.funcionalidade.nmeGrupo) {
            return  this.bscobrancaTranslate.getText('mensagens.funcionalidade-010');
        }
        if (!this.aplicacao) {
            return  this.bscobrancaTranslate.getText('mensagens.funcionalidade-011');
        }
        if (!this.targetPerfil || this.targetPerfil.length === 0) {
            return  this.bscobrancaTranslate.getText('mensagens.funcionalidade-012');
        }
        return '';
    }

    hideDialog() {
        this.funcionalidadeDialog = false;
        this.submitted = false;
    }

    findPerfilIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.perfis.length; i++) {
            if (this.perfis[i].codPerfil === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.funcionalidades.length; i++) {
            if (this.funcionalidades[i].codFuncionalidadeApp === id) {
                index = i;
                break;
            }
        }
        return index;
    }

}
